import { StyledScimProvisioning } from './ScimProvisioning.style';
import useScimSetting from 'common/hooks/settings/useScimSetting';
import useApiTokens from 'common/fetchHooks/useApiTokens';
import ScimStatusBar from '../../../components/SettingStatusBar/status-bars/ScimStatusBar';
import EmptyTokensView from './EmptyTokensView';
import ScimSetting from './ScimSetting/ScimSetting';
import Loader from './Loader';

const ScimProvisioning = () => {
  const scimSetting = useScimSetting();
  const apiTokens = useApiTokens();

  if (apiTokens.isLoading) return <Loader />;

  return (
    <StyledScimProvisioning>
      <ScimStatusBar />
      {apiTokens.isActiveTokenExists || scimSetting.isEnabled ? (
        <ScimSetting />
      ) : (
        <EmptyTokensView />
      )}
    </StyledScimProvisioning>
  );
};

export default ScimProvisioning;
